export default __webpack_public_path__ + "./assets/logo-black__09fcc9b5e1bdccde0d599485de66dec8.png";